import { isIgnoredApiError } from "@/sentry/ignored-api-errors.ts";
import type { ErrorEvent, EventHint } from "@sentry/react";

export const beforeSend = (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const error = hint?.originalException as any;
  if (error?.isAxiosError && event.exception?.values?.[0]) {
    const method = (error.config?.method || "").toUpperCase();
    const url = error.config?.url || "";
    const status = error.response?.status || "";
    const responseError = error.response?.data?.error;

    if (responseError?.trace_id) {
      event.tags = { ...event.tags, trace_id: responseError.trace_id };
    }

    const validationErrors: { field: string; code: string; message: string }[] =
      responseError?.validation_errors || [];
    const codes = [responseError?.code, ...validationErrors.map(({ code }) => code)].filter(
      (code): code is string => Boolean(code)
    );

    let apiMessage: string;
    if (validationErrors.length) {
      apiMessage = validationErrors.map(({ field, message }) => `${field}: ${message}`).join(", ");
    } else {
      apiMessage = [responseError?.code, responseError?.message].filter(Boolean).join(": ");
    }

    if (isIgnoredApiError({ method, url, status, codes, message: apiMessage })) {
      return null;
    }

    event.exception.values[0].type = `ApiError ${status}`;
    event.exception.values[0].value = [method, url, apiMessage].filter(Boolean).join(" — ");
  }
  return event;
};
